import { take, call, put, fork, all } from 'redux-saga/effects';
import fetchApi from '../../../../../utils/fetchApi';

function* getAllSummariesFlow() {
	const INFINITE = true;

	while (INFINITE) {
		const { payload: { filter, clearState }, next } = yield take('GET_ALL_SUMMARIES');
		if (clearState) {
			yield put({ type: 'RESET_STATE' });
		}
		try {
			const response = yield call(fetchApi, `SaleSummaries?filter=${JSON.stringify(filter)}`);
			if (response && !response.error) {
				yield put({ type: 'GET_ALL_SUMMARIES_SUCCESS', payload: response, filter });
				if (next && typeof next === 'function') {
					next();
				}
			}
		} catch (err) {
			yield put({ type: 'REQUEST_ERROR', payload: err });
		}
	}
}

function* getInvoicePDFFlow() {
  const INFINITE = true

  while (INFINITE) {
    const { payload, next } = yield take('GET_INVOICE_PDF')

    try {
      const response = yield call(fetchApi, `SaleSummaries/pdf-reports/export`, payload, { method: 'POST' })
      if (response && !response.error) {
        if (next && typeof next === 'function') {
          next(response)
        }
      }
    } catch (err) {
      yield put({ type: 'REQUEST_ERROR', payload: err })
    }
  }
}

function* editSummaryFLow() {
	const INFINITE = true;

	while (INFINITE) {
		const { payload, next } = yield take('EDIT_SUMMARY');
		try {
			const response = yield call(fetchApi, `SaleSummaries/${payload.payload.id}`, payload.payload.formData, { method: 'PATCH' });
			if (response && !response.error) {
				yield put({ type: 'EDIT_SUMMARY_SUCCESS', payload: response });
				if (next && typeof next === 'function') {
					next();
				}
			}
		} catch (err) {
			yield put({ type: 'REQUEST_ERROR', payload: err });
		}
	}
}

function* exportCSVFlow() {
	const INFINITE = true;

	while (INFINITE) {
		const { payload: { filter }, next } = yield take('EXPORT_CSV');
		try {
			const response = yield call(fetchApi, `SaleSummaries?filter=${JSON.stringify(filter)}`);
			if (response && !response.error) {
				yield put({ type: 'EXPORT_CSV_SUCCESS', payload: response });
				if (next && typeof next === 'function') {
					next();
				}
			}
		} catch (err) {
			yield put({ type: 'REQUEST_ERROR', payload: err });
		}
	}
}

function* getInvoiceListFlow() {
  const INFINITE = true

  while (INFINITE) {
    const {
      payload: { filter, accountId },
      next
    } = yield take('GET_INVOICE_LIST')

    try {
      // const response = yield call(fetchApi, `Invoices?filter=${JSON.stringify(filter)}`)
      const response = yield call(fetchApi, `Accounts/${accountId}/invoices?filter=${JSON.stringify(filter)}`)
      if (response && !response.error) {
        yield put({ type: 'GET_INVOICE_LIST_SUCCESS', payload: response })
        if (next && typeof next === 'function') {
          next()
        }
      }
    } catch (err) {
      yield put({ type: 'REQUEST_ERROR', payload: err })
    }
  }
}

export function* summariesListFlow() {
	yield fork(getAllSummariesFlow);
  yield fork(getInvoicePDFFlow);
	yield fork(editSummaryFLow);
	yield fork(exportCSVFlow);
	yield fork(getInvoiceListFlow);
}



// WEBPACK FOOTER //
// ./routes/admin/routes/summary-list/saga/list.js